const license = {
    not_installed: 'No hay ninguna licencia instalada en esta instancia.',
    invalid_key: 'La clave de licencia no es válida o ha sido manipulada.',
    expired_key: 'La clave de licencia ha caducado. Obtén una nueva clave e instálala de nuevo.',
};
export default Object.freeze(license);
